import React, { useState, useEffect } from "react";

const BANNER_HEIGHT = 20;

const OfflineBanner = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      width: "100%",
      backgroundColor: "#ffcc00",
      color: "#333",
      textAlign: "center",
      height: `${BANNER_HEIGHT}px`,
      lineHeight: `${BANNER_HEIGHT}px`,
      fontWeight: "bold",
      zIndex: 1000,
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      fontSize: "14px",
      overflow: "hidden",
      WebkitTransform: "translateZ(0)",
    }}
  >
    Browser offline
  </div>
);

const OfflineReloadGuard = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(false);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    const handleKeyDown = (e) => {
      const isRefreshKey =
        e.key === "F5" ||
        ((e.key === "r" || e.key === "R") && (e.ctrlKey || e.metaKey));

      if (!isOnline && isRefreshKey) {
        e.preventDefault();
        setShowBanner(true);
      }
    };

    const handleBeforeUnload = (e) => {
      if (!isOnline) {
        e.preventDefault();
        e.returnValue = "";
        setShowBanner(true);
      }
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isOnline]);

  return (
    <>
      {showBanner && <OfflineBanner />}
      {showBanner && <div style={{ height: `${BANNER_HEIGHT}px` }} />}
      <div>{children}</div>
    </>
  );
};

export default OfflineReloadGuard; 